module.exports = __webpack_public_path__ + "img/sol.f25ad82d.png";